import { ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface ScrollToBottomProps {
  visible: boolean;
  onClick: () => void;
}

export function ScrollToBottom({ visible, onClick }: ScrollToBottomProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "absolute left-1/2 -translate-x-1/2 bottom-2",
        "flex items-center justify-center",
        "h-8 w-8 rounded-full",
        "bg-intri-surface shadow-intri-md",
        "text-intri-muted hover:text-intri-dim",
        "transition-all duration-normal",
        "z-[5]",
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-2 pointer-events-none",
      )}
      aria-label="Scroll to bottom"
    >
      <ArrowDown size={14} />
    </button>
  );
}
